'use client';

import ReactImgix, { Picture, Source } from "./react-imgix";
import { PublicConfigAPI } from "./config";
import { buildURLPublic as buildURL } from "./constructUrl";
import { ImgixProvider } from "./HOCs";
export { ImgixProvider };
export { buildURL };
export { Picture, Source, PublicConfigAPI };
export { Background } from "./react-imgix-bg";
export default ReactImgix;
//# sourceMappingURL=index.js.map